import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearCredentials, setCredentials } from "../../authSlice";
import toast from "react-hot-toast";

function HistoricalReports() {
  const { token } = useSelector((state) => state.auth);
  const [allCustomers, setAllCustomers] = useState([]);
  const [selectedClient, setSelectedClient] = useState("");
  const [selectedDateFrom, setSelectedDateFrom] = useState("");
  const [selectedDateTo, setSelectedDateTo] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    const fetchCustomers = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/auth/getAllCustomers`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 401) {
          setTokenExpired(true);
        }

        if (response.ok) {
          const newAccessToken = response.headers.get("Authorization");
          if (newAccessToken) {
            dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
          }
          const data = await response.json();
          setAllCustomers(data.customers || []);
        } else {
          throw new Error("Failed to fetch customers.");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };

    if (tokenExpired) {
      dispatch(clearCredentials());
      return;
    }

    if (!token || token === "null") {
      dispatch(setCredentials({ token: null, username: null }));
    }
    if (token) {
      fetchCustomers();
    }
  }, [dispatch, token, tokenExpired]);

  const exportHistoricalReport = async () => {
    if (!selectedClient) return;
    setLoading(true);

    const url =
      selectedDateFrom && selectedDateTo && selectedClient
        ? `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofDateRangeFilter?customerId=${selectedClient}&startDate=${selectedDateFrom}&endDate=${selectedDateTo}`
        : selectedDateFrom
        ? `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofDateRangeFilter?customerId=${selectedClient}&startDate=${selectedDateFrom}`
        : selectedDateTo
        ? `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofDateRangeFilter?customerId=${selectedClient}&endDate=${selectedDateTo}`
        : `${process.env.REACT_APP_API_URL}/sales/getSalespdfonbasisofDateRangeFilter?customerId=${selectedClient}`;
    try {
      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 401) {
        dispatch(clearCredentials());
        return;
      }

      if (response.ok) {
        const newAccessToken = response.headers.get("Authorization");
        if (newAccessToken) {
          dispatch(setCredentials({ token: newAccessToken.split(" ")[1] }));
        }
        const blob = await response.blob();
        // Create a download URL for the blob
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = downloadUrl;
        const filteredItems = allCustomers.filter(
          (customer) => customer._id === selectedClient
        );
        link.download = `Report-${filteredItems[0].name}.pdf`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } else {
        throw new Error("Failed to fetch report.");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="whiteBgDiv dashboardTablePadding">
        <div className="mainHeading">
          Export Historical Reports / Sale Parchi
        </div>
        <div className="formHeading UserManagementpage"></div>
        <div
          className="d-flex flex-wrap flex-lg-nowrap"
          style={{ gap: "16px" }}
        >
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Client</label>
            <select
              name="client"
              className="form-select"
              value={selectedClient}
              onChange={(e) => setSelectedClient(e.target.value)}
            >
              <option value="">Choose Client</option>
              {allCustomers.map((customer) => (
                <option key={customer._id} value={customer._id}>
                  {customer.name}
                </option>
              ))}
            </select>
          </div>
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Date From</label>
            <input
              name="DateFrom"
              placeholder="Choose Date"
              type="date"
              id="date"
              value={selectedDateFrom}
              onChange={(e) => setSelectedDateFrom(e.target.value)}
            />
          </div>
          <div
            className="formInputLabelBox"
            style={{ flex: "1", minWidth: "250px" }}
          >
            <label>Date To</label>
            <input
              name="DateTo"
              placeholder="Choose Date"
              type="date"
              id="date"
              value={selectedDateTo}
              onChange={(e) => setSelectedDateTo(e.target.value)}
            />
          </div>
        </div>
        <div className="UserManagementBtnFlexDiv">
          {loading ? (
            <button className="grayBtn">Loading...</button>
          ) : (
            <button className="colorBtn" onClick={exportHistoricalReport}>
              Export
            </button>
          )}
        </div>
      </div>
    </>
  );
}

export default HistoricalReports;
